import React, { useEffect, useRef, useState } from "react";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { csv } from "d3-fetch";
import { prepareData, createCharts } from "utils/ep1util";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import ListItemText from "@material-ui/core/ListItemText";
import Input from "@material-ui/core/Input";
import Checkbox from "@material-ui/core/Checkbox";
import { Auth, Storage } from "aws-amplify";
import { DataStore } from "@aws-amplify/datastore";
import { Users } from "models";
// import TextField from '@material-ui/core/TextField';
// import Autocomplete from '@material-ui/lab/Autocomplete';
import MenuItem from "@material-ui/core/MenuItem";
import { makeStyles } from "@material-ui/core/styles";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const useStyles = makeStyles((theme) => ({
  button: {
    marginLeft: theme.spacing(2),
  },
  chartTitle: {
    textAlign: "center",
    margin: theme.spacing(2),
  },
  formControl: {
    marginRight: theme.spacing(4),
    minWidth: 300,
    maxWidth: 400,
  },
}));
export default function EyepieceOneResult(props) {
  const classes = useStyles();
  const [message, setMessage] = useState(null);
  // const [domains, setDomains] = useState(null);

  const [allData, setAllData] = useState(null);
  const [data, setData] = useState(null);
  const [otherData, setOtherData] = useState(null);
  // const [displayData, setDisplayData] = useState(null);
  // const [otherDisplayData, setOtherDisplayData] = useState(null);
  const [labels, setLabels] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [school, setSchool] = useState('');
  const [allSchools, setAllSchools] = useState([]);
  const myChartRefs = useRef([]);
  const otherChartRefs = useRef([]);
  const [showOtherSchool, setShowOtherSchool] = useState(false);
  const [questions, setQuestions] = useState([
    "Grade Level",
    "Subjects Taught",
    "Age",
    "Years taught throughout career",
    "Years in current role",
    "Years taught in 1:1 setting",
  ]);
  const [total, setTotal] = useState(0);
  const [otherTotal, setOtherTotal] = useState(0);
  
  useEffect(async () => {
    const file = await Storage.get("eyepiece1-data.csv", { level: 'public' });
    Promise.all([
      csv(file),//csv("assets/eyepiece1-data.csv"),
      csv("assets/eyepiece1-data-labels.csv"),
    ]).then(async ([data, labels]) => {
      // remove missing rows
      data = data.filter((d) => d["Finished"] === "TRUE");
      setAllData(data);
      // filter by the user's school
      const user = await Auth.currentAuthenticatedUser();
      const users = await DataStore.query(Users, (d) =>
        d.email("eq", user.attributes.email)
      );
      const school = users[0].school;
      

      const groups =
        user.signInUserSession.accessToken.payload["cognito:groups"];
      // console.log("ADMIN", groups, groups.indexOf("Admin") !== -1);
      if (groups){
        setIsAdmin(groups.indexOf("Admin") !== -1);
      }
      
      // setDisplayData(JSON.parse(JSON.stringify(myDisplayData)));
      // setOtherDisplayData(JSON.parse(JSON.stringify(otherDisplayData)));
      // createCharts(myDisplayData, myChartRefs.current);
      // const allSchools = Array.from(new Set(data.map((d) => d["Q2"])));
      let allUsers = await DataStore.query(Users);
      const allSchools = Array.from(new Set(allUsers.map((d) => d.school)));
      setAllSchools(allSchools);
      setLabels(labels);
      console.log("user, school", user, school, allSchools);
      initialize(data, labels, school, allSchools);


      
      // const list = await Storage.list("", { level: 'protected' });
      // console.log("FILE", file);
      // console.log("LIST", list);
    });
  }, []); // load once

  // useEffect(() => {
  //   if (!data) {
  //     return;
  //   }
  //   const myDisplayData = filterData(data, questions);
  //   console.log('myDisplayData', myDisplayData);
  //   createCharts(myDisplayData, questions, myChartRefs.current, (filteredRecords) => {
  //     setTotal(filteredRecords);
  //   });
  // }, [data]); // called once

  // useEffect(() => {
  //   if (!otherData || !showOtherSchool) {
  //     return;
  //   }
  //   createCharts(otherData, otherChartRefs.current, "#bdbdbd", "#29b6f6");
  // }, [showOtherSchool]);

  useEffect(() => {
    if (!data) {
      return;
    }
    console.log("myChartRefs", myChartRefs.current.length);
    console.log("otherChartRefs", otherChartRefs.current.length);

    let displayData = filterData(data, questions);

    createCharts(
      displayData,
      questions,
      myChartRefs.current,
      (filteredRecords) => {
        setTotal(filteredRecords);
      }
    );
    console.log("showOtherSchool", showOtherSchool);
    if (showOtherSchool) {
      displayData = filterData(otherData, questions);
      createCharts(
        displayData,
        questions,
        otherChartRefs.current,
        (filteredRecords) => {
          setOtherTotal(filteredRecords);
        },
        "#bdbdbd",
        "#29b6f6"
      );
    }
  }, [data, otherData, showOtherSchool, questions]);
  function initialize(data, labels, school, allSchools) {
    let otherSchools = allSchools.filter(
      (s) => s !== school
    );
    const myData = prepareData(data, labels, [school]);
    const otherData = prepareData(data, labels, otherSchools);
    console.log("OTHER DATa", otherData, otherSchools);
    setSchool(school);
    setTotal(data.filter((record) => record["Q2"] === school).length);
    setOtherTotal(
      data.filter((record) => otherSchools.includes(record["Q2"])).length
    );
    // const otherDisplayData = filterData(otherData, questions);
    setAllData(data);
    setData(JSON.parse(JSON.stringify(myData)));
    setOtherData(JSON.parse(JSON.stringify(otherData)));
  }

  function filterData(data, questions) {
    const filteredData = Object.entries(data)
      .filter((d) => questions.includes(d[0]))
      .reduce((acc, d) => {
        acc[d[0]] = d[1];
        return acc;
      }, {});
    console.log("filteredData", filteredData);
    return filteredData;
  }
  function handleSchoolChange(event) {
    setSchool(event.target.value);
    initialize(allData, labels, event.target.value, allSchools);
  }
  function handleSeeOtherSchool(event) {
    setShowOtherSchool(event.target.checked);
  }
  function handleShowQuestions(e) {
    console.log("questions", questions);
    setQuestions(e.target.value);
  }
  return (
    <Container>
      {isAdmin && (
        <Box pb={2}>
          <FormControl className={classes.formControl} margin="normal">
            <InputLabel id="select-school">School</InputLabel>
            <Select
              labelId="select-school"
              id="school-select"
              value={school}
              onChange={handleSchoolChange}
            >
              {allSchools.map(
                (school) =>  <MenuItem key={school} value={school}>
                {school}
              </MenuItem>
              )}
            </Select>
          </FormControl>
        </Box>
      )}
      {message && <Box p={3}>{message}</Box>}
      {data && (
        <Grid container spacing={3}>
          <Grid item xs>
            <FormControl className={classes.formControl} fullWidth>
              <InputLabel id="demo-mutiple-checkbox-label">
                Select questions to visualize
              </InputLabel>
              <Select
                labelId="demo-mutiple-checkbox-label"
                id="demo-mutiple-checkbox"
                multiple
                value={questions}
                onChange={handleShowQuestions}
                input={<Input />}
                renderValue={(selected) => selected.join(", ")}
                MenuProps={MenuProps}
              >
                {Object.keys(data).map((question) => (
                  <MenuItem key={question} value={question}>
                    <Checkbox checked={questions.indexOf(question) > -1} />
                    <ListItemText primary={question} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs>
            <FormControlLabel
              control={
                <Checkbox
                  checked={showOtherSchool}
                  onChange={handleSeeOtherSchool}
                  name="checkedB"
                  color="primary"
                />
              }
              label="Compare with Other Schools"
            />
          </Grid>
        </Grid>
      )}
      <Grid container>
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={6}>
              <Box margin={2}>
                <Typography variant="button" gutterBottom>
                  Total Responses: {total}
                </Typography>
              </Box>
            </Grid>
            {showOtherSchool && (
              <Grid item xs={6}>
                <Box margin={2}>
                  <Typography variant="button" gutterBottom>
                    Total Responses (Other Schools): {otherTotal}
                  </Typography>
                </Box>
              </Grid>
            )}
          </Grid>
        </Grid>
        <Grid item xs={12}>
          👉🏻 Click bars, or categories, to filter responses across all questions.<br/>
          👉🏽 Double click the chart to clear the selection
          👌🏿 Use the shift-key to select multiple bars <br/>
          👋🏼 For a horizontal histogram, click and drag to perform an interval selection
        </Grid>
        {questions.map((d, i) => {
          return (
            <Grid key={i} item xs={4}>
              <Typography
                className={classes.chartTitle}
                variant="body1"
                display="block"
                gutterBottom
              >
                {d}
              </Typography>
              <Grid container>
                <Grid item xs>
                  {/* <Typography
                    className={classes.chartTitle}
                    variant="body2"
                    gutterBottom
                  >
                    My School
                  </Typography> */}
                  <Box
                    ref={(el) => (myChartRefs.current[i] = el)}
                    width="100%"
                  ></Box>
                </Grid>
                {showOtherSchool && (
                  <Grid item xs>
                    {/* <Typography
                      className={classes.chartTitle}
                      variant="body2"
                      gutterBottom
                    >
                      Other Schools
                    </Typography> */}
                    <Box
                      ref={(el) => (otherChartRefs.current[i] = el)}
                      width="100%"
                    ></Box>
                  </Grid>
                )}
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Container>
  );
}
